import { Link } from "react-router-dom";
import { usePageNav } from "@/components/site/nav";

export const Logo = ({ className = "" }) => {
  const { goTop } = usePageNav();
  return (
    <Link
      to="/"
      onClick={goTop}
      data-testid="brand-logo"
      className={`group inline-flex items-center gap-2.5 ${className}`}
      aria-label="Velora Intelligence home"
    >
      <span className="relative grid h-9 w-9 place-items-center rounded-xl bg-gradient-to-br from-teal-500/25 to-teal-600/5 ring-1 ring-teal-500/40">
        <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M3 4l6.2 15.5c.4 1 1.8 1 2.2 0L21 4"
            stroke="#00E5FF"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="12" cy="12.5" r="2.1" fill="#00E5FF" />
        </svg>
        <span className="absolute inset-0 rounded-xl bg-teal-500/0 blur-md transition-colors duration-500 group-hover:bg-teal-500/25" />
      </span>
      <span className="font-display text-[17px] font-extrabold leading-none tracking-tight text-white">
        Velora <span className="text-teal-400">Intelligence</span>
      </span>
    </Link>
  );
};
